import { combineReducers } from "redux";

import templateReducer from "./templateReducer";
import adminAuthReducer from "./adminAuthReducer";

export default combineReducers({
  template: templateReducer,
  adminAuth: adminAuthReducer
});
